import { graphql, Link, StaticQuery } from "gatsby"
import React from "react"
import { Container } from "react-bootstrap"
import Anouncement from "../components/Anouncement"
import GuideSection from "../components/GuideSection"
import Layout from "../components/Layout"
import ProductDetail from "../components/ProductDetail"
import DesignSection from "../components/DesainSection"
import ProductCards from "../components/ProductCards"
import OtherDesignSection from "../components/OtherDesignSection"
import SEO from "../components/seo"

export default function productTemplate({ data }) {
  const { frontmatter, html, id } = data.markdownRemark

  return (
    <Layout>
      <SEO title={frontmatter.title} />
      <Anouncement />

      <Container className="my-5">
        <Link to="/katalog" className="btn btn-link text-secondary mb-5">
          Kembali ke katalog
        </Link>
        <ProductDetail
          title={frontmatter.title}
          html={html}
          stock={frontmatter.stock}
          bahan={frontmatter.bahan}
          onSale={frontmatter.onSale}
          price={frontmatter.price}
          ukuran={frontmatter.ukuran}
          image={frontmatter.image}
          imageTwo={frontmatter.imageTwo}
        />
        <GuideSection />
        <OtherDesignSection oldId={id} />
      </Container>
      <DesignSection />
    </Layout>
  )
}
export const query = graphql`
  query($slug: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      id
      frontmatter {
        title
        price
        bahan
        ukuran
        onSale
        stock
        image
        imageTwo
      }
    }
  }
`
